import { coworking_place_types } from 'Shared/options';
export default function getWidgetValuesFromUrl() {
  let city = decodeURI((document.location.href.split('?')[0] || '').replace(document.location.origin, '').split('/')[3] || '');
  if (city) {
    var city_name = city.includes('#') ? city.slice(0, city.lastIndexOf('#')) + ' (' + city.slice(city.lastIndexOf('#') + 1, city.lastIndexOf('#') + 3) + ')' : city;
  }
  let type = document.location.pathname.split('/')[2];
  if (!type || type === 'tous' || type === 'all') {
    type = 'all';
  } else if (type === 'seminaires') {
    type = 'meeting';
  } else {
    const match = coworking_place_types.find(opt => opt.value === type || opt.new_value === type);
    type = match ? match.new_value : 'all';
  }
  return {
    'space-type': type,
    research: {
      label: city_name,
      value: city
    }
  };
}
